import { useMemo, useState } from 'react'
import { IsListNotEmpty, ValueReferances } from '../utils'
import { isValidDate } from '@/utils/dateUtils'
import { errorToast } from '@/utils/toasters'
import { scrollToFirstError } from '@/utils/scrollToError'
import { Validations } from '@/utils/validations'

const useForm = () => {

    const [formValues, setFormValue] = useState({})

    const GetValueFromField = (value) => {
        if (Array.isArray(value)) return returnArrVauesFromList(value)
        if (typeof value === 'object' && !isValidDate(value)) return GetValueFromLookup(value || {})
        if (isValidDate(value)) return value
        return value
    }

    const returnArrVauesFromList = (list) => {
        return list.map(item => GetValueFromLookup(item))
    }

    const GetValueFromLookup = (dataObject = {}) => {
        var isLookup = Object.keys(dataObject).includes('value') || Object.keys(dataObject).includes('label')
        if (typeof dataObject === 'object' && isLookup) return dataObject?.value
    }

    const formDataResult = useMemo(() => {

        let finalFormValue = {}
        Object.entries(formValues).forEach(([key, val], index) => {
            finalFormValue[key] = GetValueFromField(val?.value)
        })

        return finalFormValue

    }, [formValues])

    const onSubmit = (formAction) => {
        if (validation()) {
            errorToast("error-validation")
            scrollToFirstError()
            return
        }
        formAction(formDataResult)
    }


    const validation = () => {
        const containError = Object.entries(formValues)
            .filter(([key, itemValue], index) => {
                let isStringEmpty = Validations.isString(itemValue?.value) && !itemValue?.value
                let isArrayEmpty = Validations.isArray(itemValue?.value) && !itemValue?.value?.length
                let isObjectEmpty = Validations.isObject(itemValue?.value) && !Validations.isArray(itemValue?.value) && !isValidDate(itemValue?.value) && !itemValue?.value?.value
                let isNull = Validations.isNull(itemValue?.value)
                let isEmpty = isStringEmpty || isArrayEmpty || isNull || isObjectEmpty
                return isEmpty && itemValue?.isRequired
            })

        let newvalues = containError.map(([key, itemValue], index) => ({ [key]: { ...itemValue, isError: true }, id_Key: key }))

        const newFormObject = { ...formValues }

        const isListNotValid = IsListNotEmpty(newvalues)
        newvalues.forEach((item, index) => {
            newFormObject[item?.id_Key] = item[item.id_Key]
        })
        setFormValue(newFormObject)
        return isListNotValid
    }

    const handleFormValues = (key, val) => {
        setFormValue(prev => ({ ...prev, [key]: val }))
    }

    const onReset = () => {
        let ObjectClearer = ValueReferances(formValues)?.cleared
        setFormValue(prev => ({ ...ObjectClearer }))
    }

    return {
        onSubmit,
        onReset,
        formHandler: { formValues, handleFormValues },  // mustly passed to fields wrapper for res params and inner destructure
        formDataResult
    }
}

export default useForm